<div #slickContextMenuRef class="slick-context-menu">
	<div #slickContextMenuDropdownMenuRef class="dropdown-menu show">
		<ng-content select="slick-context-menu-item"></ng-content>
	</div>
</div>
